import gql from 'graphql-tag';

export default gql`
    mutation DeleteProppant($input: ProppantDeleteRequest) {
        deleteProppant(input: $input) {
            errors
        }
    }
`;
